
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contactDialog.component.html',
  styleUrls: ['./contactDialog.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
})
export class ContactDialogComponent {
  orgs = [
    {
      name: 'EUROVOLC Tool',
      emails: ['md@bgs.ac.uk'],
    },
    {
      name: 'myVolcano',
      emails: ['katy@bgs.ac.uk', 'mln@bgs.ac.uk'],
    },
    {
      name: 'Tefranet',
      emails: ['tefranet@ingv.it'],
    },
    {
      name: 'INGV',
      emails: ['serviziemergenzageologica@ingv.it'],
    },
    {
      name: 'Icelandic Met Office - SO2_IMO',
      emails: ['fyrirspurnir@vedur.is'],
    },
  ];
}
